/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Option2_TitleInputs */

const tr_landing_genius_option2_title = /** @type {(inputs: Landing_Genius_Option2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kendi API Anahtarınız`)
};

const en_landing_genius_option2_title = /** @type {(inputs: Landing_Genius_Option2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Own API Key`)
};

const de_landing_genius_option2_title = /** @type {(inputs: Landing_Genius_Option2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr eigener API-Schlüssel`)
};

const ru_landing_genius_option2_title = /** @type {(inputs: Landing_Genius_Option2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш собственный API-ключ`)
};

/**
* | output |
* | --- |
* | "Your Own API Key" |
*
* @param {Landing_Genius_Option2_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_option2_title = /** @type {((inputs?: Landing_Genius_Option2_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Option2_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_option2_title(inputs)
	if (locale === "de") return de_landing_genius_option2_title(inputs)
	if (locale === "ru") return ru_landing_genius_option2_title(inputs)
	return tr_landing_genius_option2_title(inputs)
});